import { api } from './client'

export const friendsApi = {
    search: ({ firstName, lastName, city, country }) => {
        const params = new URLSearchParams()
        if (firstName) params.append('first_name', firstName)
        if (lastName)  params.append('last_name', lastName)
        if (city)      params.append('city', city)
        if (country)   params.append('country', country)
        return api.get(`/users/search?${params.toString()}`)
    },

    listFriends: () => api.get('/friends'),

    addFriend: (friendId) =>
        api.post('/friends', { friend_id: friendId }),
}
